import { handleActions } from 'redux-actions'

import {
  setAddActionUpdateList,
  setAddTaskModalInitialValue,
  setIsAddTaskModalVisible
} from 'src/store/modules/tasks'

const initialState = {
  addActionUpdateList: false,
  addTaskModalInitialValue: null,
  isAddTaskModalVisible: false
}

export default handleActions(
  {
    [setAddActionUpdateList](state, { payload: addActionUpdateList }) {
      return {
        ...state,
        addActionUpdateList
      }
    },
    [setAddTaskModalInitialValue](
      state,
      { payload: addTaskModalInitialValue }
    ) {
      return {
        ...state,
        addTaskModalInitialValue
      }
    },
    [setIsAddTaskModalVisible](state, { payload: isAddTaskModalVisible }) {
      return {
        ...state,
        isAddTaskModalVisible
      }
    }
  },
  initialState
)
